/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-non-null-asserted-optional-chain */
import { CommonModule } from "@angular/common";
import {
    Component,
    computed,
    HostListener,
    inject,
    input,
    output,
} from "@angular/core";
import { toObservable } from "@angular/core/rxjs-interop";
import { BaseConfig } from "../../../common/config/config.adapter";
import { SelectStore } from "../../select.store";

export type SelectOutput = {
    value: any;
    label: string;
};

@Component({
    selector: "app-multiple-select-option-adapter",
    template: ``,
    standalone: true,
    imports: [CommonModule],
})
export class MultipleSelectOptionAdapter<T> extends BaseConfig {
    readonly store = inject(SelectStore);

    customEvent = output<any>();

    @HostListener("click", ["$event"]) onClick(ev: any) {
        this.select.emit({
            label: this.label(),
            value: this.value(),
        });
    }

    currentValue = input<any[]>(); // 부모 컴포넌트의 value
    bindLabel = input<string>();
    bindValue = input<string>();

    // 아이템이 선택되었을 때 발생하는 이벤트
    select = output<SelectOutput>();

    // 부모 컴포넌트의 keyboard 이벤트가 css hover이벤트와 따로 동작해서 추가함
    mouseEnter = output<void>();
    mouseLeave = output<void>();

    option = input<T>();

    // 포커스 상태(키보드 이벤트 시 사용)
    focus = input<boolean>(false);
    focus$ = toObservable(this.focus);

    renderItem = input<any>();

    label = computed(() =>
        this.store.getLabel(this.option(), this.bindLabel()!),
    );
    value = computed(() =>
        this.store.getValue(this.option(), this.bindValue()!),
    );
    active = computed<boolean>(
        () => this.currentValue()?.includes(this.value())!,
    );
}
